// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ub6E","colMin":"styles_colMin__3n-_B"};